/**
 * DOM id shared between the menu page's section elements and the section
 * nav's scroll-spy, so both sides always agree on anchor targets.
 */
const menuSectionAnchorId = (sectionId: string): string => `menu-section-${sectionId}`

export { menuSectionAnchorId }
